
export const NOTIFICATION_CATEGORIES = {
  ORGANISER: "organiser",
  CHALLENGER: "challenger",
  AUDIENCE: "audience",
};

export const NOTIFICATION_ACTION_TYPES = {
  // New Attendance Flow
  ATTENDANCE_REMINDER: "attendance-reminder",
  ATTENDANCE_MISSED: "attendance-missed",
  OPPONENT_ALERT: "opponent-alert",
  AUDIENCE_ALERT: "audience-alert",
  EVENT_AWARDED: "event-awarded",
  ACCOUNT_WARNING: "account-warning",

  // Existing/Legacy Types
  ACCEPT_REJECT: "accept_reject",
  CHALLENGE_RESPONSE: "challenge_response",
  EVENT_UPDATE: "event_update",
  EVENT_UPDATE_STATUS: "event_update_status",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
  STAKE_LOST: "stake_lost",
  CHALLENGE_REQUEST: "challenge_request",

  // Older Check-in types (for graceful transition)
  CHECK_IN: "check-in",
  CHECK_IN_MISSED: "check-in-missed",
  ORGANISER_CHECK_IN: "organiser_check_in",
  CHALLENGER_CHECK_IN: "challenger_check_in",
};
